<template>
  <b-container id="app" :class="{'dark-theme': input.dark}">
    <div class="background"></div>
    <iframe
      :src="iframe_src"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
      class="d-none"
      name="gform"
    ></iframe>
    <b-form method="POST" :action="form_action" class="mb-3" target="gform" ref="form">
      <input v-for="i in input_arr" type="hidden" :key="i.name" :name="i.name" :value="getHiddenFormValue(i)">
      <input type="hidden" :name="input.username.name" :value="'u/' + input.username.value">
      <h1 class="my-2 my-md-4 text-center"><img id="logo" src="@/assets/img/logo.png" alt="RLCD Submission Form"></h1>
      <b-row>
        <b-col sm="12" md="12" lg="12" class="mb-1">
          <DesktopMenu />
          <MobileMenu />
        </b-col>
      </b-row>
      <b-row class="mb-3 mt-2">
        <b-col sm="12" md="8" lg="9" class="mt-3 mt-md-0" align-self="center">
          <div class="d-flex justify-content-center justify-content-md-start">
            <p class="text-white mb-0">Use creator code <b-badge class="badge-rlcd">RLCUSTOMDESIGNS</b-badge> in the item shop</p>
          </div>
        </b-col>
        <b-col sm="12" md="4" lg="3" class="mt-3 mb-2 mt-md-0 mb-md-0" align-self="center">
          <div class="d-flex justify-content-center justify-content-md-end">
            <a href="https://www.reddit.com/r/rlcustomdesigns" target="_blank">
              <img src="@/assets/img/icons/reddit.svg" alt="Reddit" width="28" height="28" class="social-icon-rlcd">
            </a>
            <a href="https://discord.gg/H3Cypr3" target="_blank">
              <img src="@/assets/img/icons/discord.svg" alt="Discord" width="28" height="28" class="ml-3 social-icon-rlcd">
            </a>
            <a href="https://instagram.com/rlcustomdesigns" target="_blank">
              <img src="@/assets/img/icons/instagram.svg" alt="Instagram" width="28" height="28" class="ml-3 social-icon-rlcd">
            </a>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12" md="8" lg="9" class="mb-3">
          <VueGlow color="#E87DF3" mode="hex" fade interval="20" elevation="22" intensity="1.5" intense>
          <b-card no-body>
            <b-card-body>
              <b-row>
                <b-col sm="12" lg="7" class="mb-3">
                  <RedditOAuth :redditUser.sync="input.username.value" />
                </b-col>
                <b-col>
                  <b-form-radio-group
                    id="team-select"
                    v-model="input.team.value"
                    :options="[{text: 'Blue Team', value: 'Blue'}, {text: 'Orange Team', value: 'Orange'}]"
                    buttons
                    button-variant="outline-secondary"
                    class="d-block float-right"
                  ></b-form-radio-group>
                  <b-form-checkbox
                    id="rotate"
                    v-model="input.rotate.value"
                    name="rotate"
                    value="Yes"
                    unchecked-value="No"
                    class="d-block float-right"
                  >Rotate Car 360º <img src="@/assets/img/icons/rotate.svg" alt="Rotate" width="22" height="22">
                  </b-form-checkbox>
                </b-col>
              </b-row>
            </b-card-body>
            <b-tabs id="tabs" card>
              <TabContainer slot_name="Body">
                <ItemTab
                  :slot_items="items['Body']"
                  :input="input['Body']"
                  item_slot="Body"
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Decal">
                <ItemTab
                  :slot_items="decalsForBody()"
                  :input="input['Decal']"
                  item_slot='Decal'
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Paint Finish">
                <PaintFinishTab
                  :team="input.team.value"
                  :input="input['Paint Finish']"
                  :items="items['Paint Finish'].items"
                  :decal="{name: input['Decal'].item.value, quality: items['Decal'].quality[input['Decal'].item.value]}"
                ></PaintFinishTab>
              </TabContainer>
              <TabContainer slot_name="Wheels">
                <ItemTab
                  :slot_items="items['Wheels']"
                  :input="input['Wheels']"
                  item_slot='Wheels'
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Rocket Boost">
                <ItemTab
                  :slot_items="items['Rocket Boost']"
                  :input="input['Rocket Boost']"
                  item_slot='Rocket Boost'
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Topper">
                <ItemTab
                  :slot_items="items['Topper']"
                  :input="input['Topper']"
                  item_slot='Topper'
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Antenna">
                <ItemTab
                  :slot_items="items['Antenna']"
                  :input="input['Antenna']"
                  item_slot='Antenna'
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Trail">
                <ItemTab
                  :slot_items="items['Trail']"
                  :input="input['Trail']"
                  item_slot='Trail'
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Goal Explosion">
                <ItemTab
                  :slot_items="items['Goal Explosion']"
                  :input="input['Goal Explosion']"
                  item_slot='Goal Explosion'
                ></ItemTab>
              </TabContainer>
              <TabContainer slot_name="Map"> <!-- Technically Map is not a "slot", but TabContainer uses slot_name to get the right tab icon from the sprite, so leave this -->
                <MapTab
                  :slot_items="mapsForBuild()"
                  :input="input.map"
                  item_slot='Map'
                ></MapTab>
              </TabContainer>
            </b-tabs>
          </b-card>
          </VueGlow>
        </b-col>
        <b-col sm="12" md="4" lg="3">
          <Summary :input="input"></Summary>
          <VueGlow color="#E87DF3" mode="hex" fade interval="20" elevation="20" intensity="1.3" intense>
          <b-button
            block variant="primary"
            class="mt-4"
            type="button"
            :disabled="isSubmissionDisabled"
            v-b-modal.submitted
            @click="submit"
          >Submit</b-button>
          </VueGlow>
          <p class="text-muted text-center" v-show="getCooldown">
            {{ getCooldown }}
          </p>
        </b-col>
      </b-row>
    </b-form>
    <footer>
      <b-row class="mb-3 text-center text-muted">
        <b-col
          sm="12"
          md="4"
          class="text-md-left"
        >&copy; {{ (new Date).getFullYear() }} <a href="https://www.reddit.com/r/RLCustomDesigns/">r/RLCustomDesigns</a> • Updated 24 Aug 2022</b-col>
        <b-col
          sm="12"
          md="8"
          class="text-md-right"
        >All material about Rocket League belongs to Psyonix, Inc.</b-col>
      </b-row>
      <b-row>
        <b-col class="text-center mb-3">
          <b-form-checkbox v-model="input.dark" switch>
            Dark Theme
          </b-form-checkbox>
        </b-col>
      </b-row>
    </footer>
    <div>
      <b-modal id="submitted"
        title="Form Submitted"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        centered
        :modal-class="{'dark-theme': input.dark}">
        <p>Thanks! Once your car has been posted on r/RLCustomDesigns, we'll tag
           you in the comments to notify you.</p>
        <p>If you'd like to get an estimate for how long this will take,
           <a href="https://discord.gg/H3Cypr3">join our Discord server</a> and
           type:
        <p><code>.status u/{{ input.username.value }}</code></p>
        <p>in the #bot-commands channel. Type <code>.help</code> at any time for
           help on using the bot.</p>
        <p>Like using RL Custom Designs? Please consider supporting us to help keep it running! Use our creator code <code>RLCUSTOMDESIGNS</code> in the item shop. You can also support us via <b><a href="https://www.patreon.com/rlcustomdesigns" target="_blank">Patreon</a></b>, <b><a href="https://paypal.me/rlcustomdesigns" target="_blank">PayPal</a></b>, or <b><a href="https://www.buymeacoffee.com/rlcustomdesigns" target="_blank">Buy Me a Coffee</a></b> and get exclusive perks and roles on the subreddit and Discord. Thank you!</p>
        <template slot="modal-footer" slot-scope="{ ok, cancel }">
          <b-button @click="cancel(); activateCooldown()">Submit Another</b-button>
          <b-button
            @click="ok()"
            href="https://www.reddit.com/r/RLCustomDesigns/"
            variant="primary">Return to r/RLCustomDesigns</b-button>
        </template>
      </b-modal>
    </div>
    <div>
      <b-modal id="whats-new"
        ref="whats-new"
        title="What's New • 25 Aug 2022"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        centered
        :modal-class="{'dark-theme': input.dark}">
        <p><b>👋 Hey there! Thank you for helping us test our upcoming features! 🎉 This update adds:</b></p>
        <ul>
          <li>Goal explosions</li>
          <li>Map switching</li>
          <li>The ability to create 360º gifs of your builds</li>
        </ul>
        <p>Please provide any feedback in the #beta-testers channel on <a href="https://discord.gg/H3Cypr3" target="_blank">Discord</a>. Any requests you make here will be posted in our test subreddit, <a href="https://reddit.com/r/RLCustomDesignsCSS" target="_blank">r/RLCustomDesignsCSS</a>.</p>
        <p>If you find a legit bug that we can reproduce, we'll give you the Bug Hunter subreddit flair and Discord server role. Cheers! 🙏 🤗</p>
        <template slot="modal-footer" slot-scope="{ ok }">
          <b-button @click="ok();">OK</b-button>
        </template>
      </b-modal>
    </div>
    <div>
      <b-modal id="premium-garage-ge-warning"
        ref="premium-garage-ge-warning"
        title="Heads Up!"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
        centered
        :modal-class="{'dark-theme': input.dark}">
        <p>Due to the map's limitations, goal explosions and the premium garage can't be selected together (there's no goal in the indoor area!)<p>
        <p>Please select a different map, or choose <code>None</code> in the goal explosions tab.</p>
        <template slot="modal-footer" slot-scope="{ ok }">
          <b-button @click="ok();">I Understand</b-button>
        </template>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import Summary from './components/Summary.vue'
import ItemTab from './components/ItemTab.vue'
import MapTab from './components/MapTab.vue'
import PaintFinishTab from './components/PaintFinishTab.vue'
import TabContainer from './components/TabContainer.vue'
import RedditOAuth from './components/RedditOAuth.vue'
import DesktopMenu from './components/DesktopMenu.vue'
import MobileMenu from './components/MobileMenu.vue'
import VueGlow from 'vue-glow';


var items = require('@/items.csv') // this will actually be imported by WebPack

items['Decal'].items.unshift('None');
items['Topper'].items.unshift('None');
items['Rocket Boost'].items.unshift('None');
items['Antenna'].items.unshift('None');
items['Trail'].items.unshift('None');
items['Goal Explosion'].items.unshift('None');

// To get entry IDs, use "get pre-filled link", write down unique values for each field, and check the URL that appears in your browser
var input = {
  'Body': {
    item: {value: 'Octane', name: 'entry.354797309'},
    paint: {value: '', name: 'entry.97347633'}
  },
  'Decal': {
    item: {value: 'None', name: 'entry.289956341'},
    paint: {value: '', name: 'entry.299458977'}
  },
  'Paint Finish': {
    primary: {
      color: {value: 'D6', name: 'entry.1313414293'},
      item: {value: 'Glossy', name: 'entry.13663887'}
    },
    accent: {
      color: {value: 'A1', name: 'entry.1755825405'},
      item: {value: 'Glossy', name: 'entry.810509894'}
    }
  },
  'Wheels': {
    item: {value: 'OEM', name: 'entry.1534186341'},
    paint: {value: '', name: 'entry.2013978847'}
  },
  'Rocket Boost': {
    item: {value: 'None', name: 'entry.1724363445'},
    paint: {value: '', name: 'entry.2041985515'}
  },
  'Topper': {
    item: {value: 'None', name: 'entry.190263880'},
    paint: {value: '', name: 'entry.1689495620'}
  },
  'Antenna': {
    item: {value: 'None', name: 'entry.379283260'},
    paint: {value: '', name: 'entry.715786428'}
  },
  'Trail': {
    item: {value: 'None', name: 'entry.1446744925'},
    paint: {value: '', name: 'entry.976298418'}
  },
  'Goal Explosion': {
    item: {value: 'None', name: 'entry.1019057743'},
    paint: {value: '', name: 'entry.447144659'}
  },
  team: {value: 'Blue', name: 'entry.466605838'},
  map: {value: 'Mannfield', name: 'entry.1652160896'},
  rotate: {value: 'No', name: 'entry.1763192170'},
  username: {value: '', name: 'entry.1275796177'},
  remember: true,
  dark: true
};

if (localStorage.username) {
  input.username.value = localStorage.username;
}

if (localStorage.dark) {
  input.dark = JSON.parse(localStorage.dark);
}

var input_arr = [
  input['Body'].item,
  input['Body'].paint,
  input['Decal'].item,
  input['Decal'].paint,
  input['Wheels'].item,
  input['Wheels'].paint,
  input['Rocket Boost'].item,
  input['Rocket Boost'].paint,
  input['Topper'].item,
  input['Topper'].paint,
  input['Antenna'].item,
  input['Antenna'].paint,
  input['Trail'].item,
  input['Trail'].paint,
  input['Goal Explosion'].item,
  input['Goal Explosion'].paint,
  input['Paint Finish'].primary.color,
  input['Paint Finish'].primary.item,
  input['Paint Finish'].accent.color,
  input['Paint Finish'].accent.item,
  input.team,
  input.map,
  input.rotate
];

/* playground */
const form_id = '1FAIpQLSe5Q0HYHTZG6Nsr6hCYEuijE2ZJQypUKdf_Qu1uLIPBO3mJtg';

/* production */
// const form_id = '1FAIpQLSe03xcTUcD8TM-w7KY5KDu-TkxxyNDpyKQ7V7CjabZZfZvWNQ'; // Form for Car Design 3.0

const form_action = `https://docs.google.com/forms/u/1/d/e/${form_id}/formResponse`;
const iframe_src = `https://docs.google.com/forms/d/e/${form_id}/viewform?embedded=true`

const query_assoc = {
  'bi': input['Body'].item,
  'bp': input['Body'].paint,
  'di': input['Decal'].item,
  'dp': input['Decal'].paint,
  'wi': input['Wheels'].item,
  'wp': input['Wheels'].paint,
  'ri': input['Rocket Boost'].item,
  'rp': input['Rocket Boost'].paint,
  'ti': input['Topper'].item,
  'tp': input['Topper'].paint,
  'ani': input['Antenna'].item,
  'anp': input['Antenna'].paint,
  'tri': input['Trail'].item,
  'trp': input['Trail'].paint,
  'gei': input['Goal Explosion'].item,
  'gep': input['Goal Explosion'].paint,
  'pi': input['Paint Finish'].primary.item,
  'pc': input['Paint Finish'].primary.color,
  'ai': input['Paint Finish'].accent.item,
  'ac': input['Paint Finish'].accent.color,
  't': input.team,
  'map': input.map,
  'rot': input.rotate,
}

var query = decodeURI(window.location.search.substring(1));
const params = new URLSearchParams(query);
const parsed_params = Object.fromEntries(params);

for (const [key, value] of Object.entries(parsed_params)) {
  if (query_assoc[key]) {
    query_assoc[key].value = value;
  }
}

export default {
  data() {
    return {
      input,
      items,
      form_action,
      input_arr,
      iframe_src,
      is_on_cooldown: false
    }
  },
  components: {
    Summary,
    ItemTab,
    MapTab,
    PaintFinishTab,
    TabContainer,
    RedditOAuth,
    VueGlow,
    DesktopMenu,
    MobileMenu
  },
  methods: {
    decalsForBody: function() {
      var input_decal = input['Decal'].item.value;
      var input_body = input['Body'].item.value;
      var all_decals = items['Decal'].items;
      var decal = '';
      var body_decals = { // all the possible decals for the selected body
        paintable: items['Decal'].paintable,
        quality: items['Decal'].quality,
        items: []
      };

      for (var i in all_decals) {
        decal = all_decals[i];
        if (decal.includes(':')) {
          // match exactly the first N chars
          // to include base decals for G1/GXT Rocket Pass XBB/SC variants of cars, match first word of decal to body name
          if (decal.substring(0, input_body.length + 2) == input_body + ': ') {
            body_decals.items.push(decal);
          }
          if (input_body.includes('G1') || input_body.includes('GXT') || input_body.includes('SC') || input_body.includes('XBB')) {
            if (decal.split(':')[0] == input_body.split(' ')[0]) {
              body_decals.items.push(decal);
            }
          }
        } else { // decals with no ':', so BMDs and universals
          body_decals.items.push(decal);
        }
      }

      // a selected decal doesn't match the selected body, reset
      if (!body_decals.items.includes(input_decal)) {
        input['Decal'].item.value = 'None';
      }

      return body_decals;
    },
    mapsForBuild: function() {
      // Listed alphabetically to match the other item slots, as this is the order in which they'll be loaded on the form
      var all_maps = [
        'Beckwith Park Snow',
        'Deadeye Canyon',
        'DFH Stadium Circuit',
        'Forbidden Temple',
        'Mannfield',
        'Neo Tokyo Toon',
        'Neon Fields',
        'Premium Garage',
        'Salty Shores',
        'Shadow Realm',
        'Starbase Arc Aftermath',
        'Utopia Coliseum Snow',
        'Throwback Stadium Snow',
        'Urban Central Spooky',
        'Utopia Coliseum Gilded'
      ]

      var maps = {
        "items": []
      };

      var input_map = input.map.value;
      var input_goalexplosion = input['Goal Explosion'].item.value;

      for (var i in all_maps) {
        var map = all_maps[i];
        if (map == 'Premium Garage') {
          // Only add to maps if no goal explosion is selected
          // Similar to how only applicable decals get pushed for the body selected
          if (input_goalexplosion == 'None') {
            maps.items.push(map);
          }
        } else {
          maps.items.push(map);
        }
      }
      
      // A goal explosion was selected on premium garage, reset the map
      if (input_goalexplosion != 'None' && input_map == 'Premium Garage') {
        input.map.value = 'Mannfield';
        this.$refs['premium-garage-ge-warning'].show();
      }

      return maps;
    },
    getHiddenFormValue: function(i) {
      if (i.value.startsWith("'")) {
        return "'" + i.value;
      }

      if (i.value == 'None') {
        return '';
      }

      return i.value;
    },
    activateCooldown: function() {
      this.is_on_cooldown = true;
      setTimeout(() => {
        this.is_on_cooldown = false;
      }, 7000);
    },
    submit: function() {
      if (input.remember) {
        localStorage.username = input.username.value;
      }
      this.$refs.form.submit()
    }
  },
  computed: {
    isSubmissionDisabled: function() {
      var is_username_valid = /^[A-Za-z0-9\-_]{3,20}$/.test(this.input.username.value);
      // first check if username is valid, only then proceed to check if user is on cooldown
      // will return invalid if user is not logged in, regex check is not necessary any more, OAuth login ensures legit account every time
      if (is_username_valid == true) {
        if (this.is_on_cooldown == true) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    getCooldown: function() {
      if (this.is_on_cooldown == true) {
        // TODO: add calculation to show time left in waiting period
        return 'Submit disabled for 7 seconds.';
      }
      return false;
    }
  },
  watch: {
    'input.dark': function(val) {
      localStorage.dark = val;
    }
  }
}
</script>

<style>
#logo {
  /* width: 64px; */ /* use if classic rlcd logo */
  width: 198px; /* use if wide logo */
  /*width: 158px;*/
  height: 64px;
}

/* narrow screens */
#tabs li.nav-item {
  width: calc(100% / 5);
}

#tabs li.nav-item .nav-link {
  padding: 0.2em;
}

#tabs li.nav-item div {
  margin: auto;
}

@media (min-width: 768px) {
  /* reset to default */
  #tabs li.nav-item {
    width: auto;
  }
  #tabs li.nav-item .nav-link {
    padding: 0.5em 1em;
  }
  #logo {
    /* width: 96px; */ /* use if classic rlcd logo */
    width: 296px;
    /*width: 237px;*/ /* use if medium logo */
    height: 96px;
  }
}
</style>